import { useState, useEffect } from "react";
import axios from "axios";
import botImageHeader from "../../assets/images/chatbot_icon.png";
import botVideo from "../../assets/videos/chatbot_hi_animate.webm";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getQuestionText = (faq) => {
  return faq?.question || faq?.title || faq?.option_text || faq?.option_name || "";
};

const getQuestionId = (faq, index) => {
  return faq?.content_id || faq?.faq_id || faq?.option_id || faq?.id || `faq-${index}`;
};

const WelcomeScreen = ({
  onClose,
  user,
  setScreen,
  setPendingMessage,
}) => {
  const [message, setMessage] = useState("");
  const [faqList, setFaqList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    const fetchFaqQuestions = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/faq-questions`);
        const questions = Array.isArray(response.data?.data) ? response.data.data : [];

        setFaqList(questions);
        setLoadError(questions.length ? "" : "No questions found.");
      } catch (error) {
        console.error("Error fetching FAQ questions from backend:", error);
        setFaqList([]);
        setLoadError("Unable to load questions. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchFaqQuestions();
  }, []);

  const handleFaqClick = (faqItem) => {
    setPendingMessage(faqItem);
    setScreen("chat");
  };

  // const handleOthersClick = () => {
  //   setPendingMessage("Others...");
  //   setScreen("chat");
  // };

  const handleSendMessage = () => {
    if (message.trim()) {
      setPendingMessage(message.trim());
      setMessage("");
      setScreen("chat");
    }
  };

  return (
    <>
      <div className="chat-header">
        <div className="chat-header-left">
          <img
            src={botImageHeader}
            alt="IntelliBot"
            className="chat-avatar"
          />
          <div>
            <h4 className="chat-title">IntelliBot</h4>
            <div className="chat-status">Online</div>
          </div>
        </div>
        <button className="chat-close" onClick={onClose}>&times;</button>
      </div>

      <div className="chat-body welcome-chat-body">
        <div className="welcome-section-new">
          <video
            src={botVideo}
            className="welcome-avatar-new"
            autoPlay
            muted
            playsInline
            loop={true}
          />
          <div className="welcome-text-wrapper-new">
            <h2 className="welcome-title-new">
              Welcome!<br />
              <span className="user-name">{user?.name || "Guest"}</span>
            </h2>
            <p className="welcome-subtitle-new">How can I assist you?</p>
          </div>
        </div>

        <div className="questions-section">
          {loading ? (
            <div className="loading-questions" style={{ textAlign: "center", padding: "15px", color: "#888" }}>
              Loading...
            </div>
          ) : (
            <>
              {loadError && (
                <div className="loading-questions" style={{ textAlign: "center", padding: "15px", color: "#888" }}>
                  {loadError}
                </div>
              )}

              {faqList.map((faq, index) => {
                const questionText = getQuestionText(faq);

                if (!questionText) return null;

                return (
                  <button
                    key={getQuestionId(faq, index)}
                    className="question-btn"
                    onClick={() => handleFaqClick(faq)}
                  >
                    <span className="question-text">{questionText}</span>
                    <span className="question-arrow">&rarr;</span>
                  </button>
                );
              })}

              {/* <button
                className="question-btn others-btn"
                onClick={handleOthersClick}
              >
                <span className="question-text">Others...</span>
                <span className="question-arrow">&rarr;</span>
              </button> */}
            </>
          )}
        </div>
      </div>

      <div className="chat-footer">
        {/* <div className="chat-input-wrapper">
          <input
            type="text"
            className="chat-input-field"
            placeholder="Type your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && message.trim()) {
                handleSendMessage();
              }
            }}
          />
          <button
            className="send-message-btn"
            onClick={handleSendMessage}
            disabled={!message.trim()}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M22 2L11 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div> */}
        <div className="footer-brand">
          <span>Powered by SwiftIntelli AI</span>
        </div>
      </div>
    </>
  );
};

export default WelcomeScreen;
